export default function ContactMap() {
  return (
    <div className="w-full h-full min-h-[420px] rounded-2xl overflow-hidden shadow-lg border border-slate-100">
      <iframe
        title="CJ Solutions Office Location - Limassol, Cyprus"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52326.23!2d33.0!3d34.685!2m3!1f60!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14e7335f5e5e5e5f%3A0x0!2sLimassol%2C+Cyprus!5e1!3m2!1sen!2s!4v1700000000000!5m2!1sen!2s"
        width="100%"
        height="100%"
        style={{ border: 0, minHeight: '420px' }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}
